import * as React from 'react';
import { FontIcon, Icon } from '@fluentui/react/lib/Icon';
import '../../css/layout/topMenu.scss';
import { LeftMenuContext } from '../../context/leftMenu.context';
import {
  ContextualMenu,
  IContextualMenuItem,
  Label,
  PersonaPresence,
  PersonaSize,
  Panel,
  IconButton,
} from '@fluentui/react';
import useToken from '../../components/account/login/useToken';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useBoolean } from '@fluentui/react-hooks';
import * as Api from '../../api/src';
import moment from 'moment';
import { NoDataFound } from '../../control/noDataFound';
import { commonfn } from '../../common/commonfn';
import { Avatar } from '../../control/avatar';
import { NotificationContext } from '../../context/notification.context';
import ModalSwitchCompany from '../topMenu/modalSwitchCompany';

const NotificationsApi = new Api.NotificationsApi();
const NotificationTypeEnum = Api.NotificationTypeEnum;
const TopMenu = () => {
  const { t } = useTranslation();
  const { setIsShow, isShow } = React.useContext(LeftMenuContext);
  const { hasNoti, setHasNoti } = React.useContext(NotificationContext)
  const { userTokenInfo, currentVendor, setToken } = useToken();
  const linkRef = React.useRef(null);
  const [showContextualMenu, setShowContextualMenu] = React.useState(false);
  const [listNotifications, setListNotifications] = React.useState<Api.NotificationDto[]>([]);
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
  const [isOpenModal, setOpenSwitchCompany] = React.useState(false);

  let routerHistory = useHistory();
  const onShowContextualMenu = React.useCallback((ev: React.MouseEvent<HTMLElement>) => {
    ev.preventDefault(); // don't navigate
    setShowContextualMenu(true);
  }, []);
  const onHideContextualMenu = React.useCallback(() => setShowContextualMenu(false), []);

  const menuItems: IContextualMenuItem[] = [
    {
      key: 'UserProfile',
      text: t('UserProfile'),
      onClick: () => {
        routerHistory.push('/userprofile');
      },
    },
    {
      key: 'SwitchCompany',
      text: t('SwitchCompany'),
      onClick: () => {
        setOpenSwitchCompany(true);
      },
    },
    {
      key: 'LogOut',
      text: t('LogOut'),
      onClick: () => {
        routerHistory.push('/logout');
      },
    },
  ];

  const menuItemsSallingGroup: IContextualMenuItem[] = [
    {
      key: 'UserProfile',
      text: t('UserProfile'),
      onClick: () => {
        routerHistory.push('/userprofile');
      },
    },
    {
      key: 'LogOut',
      text: t('LogOut'),
      onClick: () => {
        routerHistory.push('/logout');
      },
    },
  ];

  const getCountNotification = async () => {
    const result = await NotificationsApi.apiNotificationsGetCountNotOpenNotiGet();
    setHasNoti(result.data !== 0)
  }
  getCountNotification();
  const getNotifications = async () => {
    const result = await NotificationsApi.apiNotificationsPagedPost();
    setListNotifications(result.data.Data || []);
    setHasNoti(false);
  };
  const navigateNotification = (item: any) => {
    switch (item.Notification.NotificationType) {
      case NotificationTypeEnum.UnApproveTest:
      case NotificationTypeEnum.ApproveTest:
        routerHistory.push('/test/detail/' + item.Notification.TestId);
        dismissPanel();
        break;
      case NotificationTypeEnum.SgUserAddProductToMatrix:
      case NotificationTypeEnum.ApproveModule:
      case NotificationTypeEnum.UnApproveModule:
      case NotificationTypeEnum.UpdateModuleDeadline:
      case NotificationTypeEnum.AddDocumentToModule:
      case NotificationTypeEnum.AddCommentToModule:
      case NotificationTypeEnum.AddModule:
      case NotificationTypeEnum.RemoveTestFromModule:
      case NotificationTypeEnum.AddTestToModule:
      case NotificationTypeEnum.NotificationBeforeModuleDeadLine:
      case NotificationTypeEnum.NotificationInModuleDeadline:
        if (item.Notification.MatrixItemId || item.Notification.MatrixItemModule?.MatrixItemId) {
          routerHistory.push(
            '/matrix/detail/' +
              (item.Notification.MatrixItemId || item.Notification.MatrixItemModule?.MatrixItemId) +
              (item.Notification.MatrixItemModuleId && '/' + item.Notification.MatrixItemModuleId),
          );
          dismissPanel();
        }
        break;
      default:
        break;
    }
    readNotification(item.Notification.Id);
  };

  const readNotification = (item: any) => {
    const params = {
      NotiIds: [item],
    };
    NotificationsApi.apiNotificationsMaskNotisIsReadPatch(params).then(() => {
      getNotifications();
    });
  };

  const readAll = () => {
    NotificationsApi.apiNotificationsMaskAllNotisIsReadPatch().then(() => {
      getNotifications();
    });
  };

  const deleteAll = async () => {
    NotificationsApi.apiNotificationsDeleteAllNotiDelete().then(() => {
      getNotifications();
    });
  };

  const formatTime = (time: any) => {
    return moment(time).fromNow();
  };

  return (
    <div className={'topMenu'}>
      <div className={'logo'}>
        <FontIcon
          className="menuIcon"
          iconName="WaffleOffice365"
          onClick={() => {
            setIsShow(!isShow);
          }}
        />
        <Label className={'title'}>{t('ProjectDevelopmentTool')}</Label>
      </div>
      <div className={'margin-left-auto'} style={{position: 'relative'}}>
        <IconButton className={'ringer margin-left-auto'} iconProps={{ iconName: 'Ringer' }} onClick={openPanel} />
        { hasNoti &&
          <Icon iconName="LocationDot" className="notiIcon"></Icon>
        }
      </div>
      <div className={'user-info'} ref={linkRef} onClick={onShowContextualMenu}>
        {userTokenInfo && (
          <Avatar
          keyColor={userTokenInfo['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] || ''}
          imageInitials={commonfn.getNameInitial(
            userTokenInfo['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
          )}
          text={userTokenInfo['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']}
          secondaryText={currentVendor ?? 'Salling group'}
          showSecondaryText={true}
          size={PersonaSize.size32}
          presence={PersonaPresence.none}
          RandomColor={true}
          color='white'
        />
        )}
        <ContextualMenu
          items={userTokenInfo?.CompanyType === Api.CompanyTypeEnum.Vendor ? menuItems : menuItemsSallingGroup}
          hidden={!showContextualMenu}
          target={linkRef}
          onItemClick={onHideContextualMenu}
          onDismiss={onHideContextualMenu}
        />
      </div>
      <Panel
        headerText="Notifications"
        closeButtonAriaLabel="Close"
        onOpen={() => {
          getNotifications();
        }}
        isOpen={isOpen}
        onDismiss={dismissPanel}
      >
        {/* <Separator /> */}
        {listNotifications.map((item) => {
          return (
            <a
              className={'itemSelection ' + (!item.Notification?.IsRead ? 'unread' : '')}
              onClick={() => {
                navigateNotification(item);
              }}
            >
              <Avatar
                keyColor={item.UserCreated?.Id?.toString()}
                imageInitials={commonfn.getNameInitial(item.UserCreated)}
                text={item.Notification?.Content || ''}
                secondaryText={formatTime(item.DateCreated)}
                size={PersonaSize.size32}
                presence={PersonaPresence.none}
                imageAlt="Avatar"
                showSecondaryText={true}
                RandomColor={true}
              />
            </a>
          );
        })}

        <div className='list_notification flex-center' style={{display: 'grid'}}>
        {!listNotifications.length && <NoDataFound isShow={true} />}
        </div>
        <div className="footer">
          {/* <CommandBarButton text={"Delete all"}/> */}
          <a
            onClick={() => {
              deleteAll();
            }}
          >
            Delete all
          </a>
          <a
            onClick={() => {
              readAll();
            }}
          >
            Mark all as read
          </a>
        </div>
      </Panel>

      {isOpenModal && (
        <ModalSwitchCompany
          IsOpen={isOpenModal}
          Item={userTokenInfo['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']}
          onCloseModal={() => {
            setOpenSwitchCompany(false);
          }}
          onSaveModal={
            (item: Api.TokenResponse) => {
              setToken(item);
              setOpenSwitchCompany(false);
              localStorage.removeItem('MatrixFilterQueryCache');
            }
          }
        ></ModalSwitchCompany>
      )}

    </div>
  );
};
export default TopMenu;
